import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../routes/pageRoutes";
import ProductSection from "../getStarted/goodKitsToStart/ProductSection";
import { fetchProducts } from "../../redux/action/orderAction";

const Products = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state?.orderReducer);

  useEffect(() => {
    dispatch(fetchProducts())
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Products"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Products", path: `${pageRoutes?.home}/` },
        ]}
      />
      <ProductSection />
      <Footer />
    </div>
  );
};

export default Products;
